// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".characteristic[data-v-6bf4620f]{display:flex;flex-direction:column;gap:8px}.characteristic__head[data-v-6bf4620f]{display:flex;flex-direction:row;align-items:center;gap:8px;border-left:2px solid #9C87FB;padding:0 16px}.characteristic__body[data-v-6bf4620f]{padding:0 16px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
